import React, { useState, useEffect, useContext } from "react";
import * as S from "./ContratosStyle";
import {
  formatDate,
  formatDateSystem,
  formatNumber,
  formatDateForInput,
  formatDateDisplay,
} from "../ASSETS/assets";
import PaginaContrato from "../PaginaDoContrato/PaginaContrato";
import { AuthContext } from "../../Context/AuthContext";
import Loading from "../Loader";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { auditService } from "../../Services/auditService";
import { contractAdminService } from "../../Services/contractAdminService";
import ModalRecibo from "../Depositos/ModalRecibo/ModalRecibo";
import { useMessage } from "../../Context/MessageContext";

function getNextWithdrawalFromList(withdrawDates) {
  if (!withdrawDates || withdrawDates.length === 0) return "Não definido";
  const now = new Date();
  const todayStart = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  ).getTime();
  const futureDates = withdrawDates
    .map((d) => {
      const dateObj = new Date(d);
      return {
        original: dateObj,
        timestamp: new Date(
          dateObj.getUTCFullYear(),
          dateObj.getUTCMonth(),
          dateObj.getUTCDate()
        ).getTime(),
      };
    })
    .filter((d) => d.timestamp >= todayStart)
    .sort((a, b) => a.timestamp - b.timestamp);
  if (futureDates.length === 0) return "Finalizado";
  const nextDate = futureDates[0];
  if (nextDate.timestamp === todayStart) {
    return "HOJE";
  }
  const day = String(nextDate.original.getUTCDate()).padStart(2, "0");
  const month = String(nextDate.original.getUTCMonth() + 1).padStart(2, "0");
  const year = nextDate.original.getUTCFullYear();
  return `${day}/${month}/${year}`;
}

export default function Contratos() {
  const { purchases, getPurchases, totalPurchases, totalPurchasesAtPlatform } =
    useContext(AuthContext);

  const [search, setSearch] = useState("");
  const [promotionSearch, setPromotionSearch] = useState("");
  const [idPurchaseSearch, setIdPurchaseSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("1");
  const [isRepurchaseFilter, setIsRepurchaseFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [orderFilter, setOrderFilter] = useState("date_desc");
  const [load, setLoad] = useState(false);
  const [itemsPerPage] = useState(10);
  const [selectedContract, setSelectedContract] = useState(null);
  const [modalRecibo, setModalRecibo] = useState(null);
  const [removeReceiptModal, setRemoveReceiptModal] = useState(null);
  const [removeReceiptConfirm, setRemoveReceiptConfirm] = useState("");
  const [metrics, setMetrics] = useState(null);
  const [loadingMetrics, setLoadingMetrics] = useState(false);
  const { showMessage } = useMessage();
  const navigate = useNavigate();

  const isSearchingById = idPurchaseSearch.trim() !== "";

  useEffect(() => {
    fetchMetrics();
  }, []);

  useEffect(() => {
    if (!isSearchingById) {
      fetchContracts(1);
    }
  }, [statusFilter, orderFilter, isRepurchaseFilter]);

  const fetchMetrics = async () => {
    setLoadingMetrics(true);
    try {
      const data = await contractAdminService.getDashboardMetrics();
      setMetrics(data);
    } catch (err) {
      console.error("Erro ao carregar métricas", err);
    } finally {
      setLoadingMetrics(false);
    }
  };

  const fetchContracts = async (page = 1) => {
    setLoad(true);
    try {
      const offset = (page - 1) * itemsPerPage;
      await getPurchases(
        itemsPerPage,
        offset,
        orderFilter,
        isSearchingById ? "" : statusFilter,
        isSearchingById ? "" : search,
        idPurchaseSearch,
        isSearchingById ? "" : promotionSearch,
        isSearchingById ? "" : isRepurchaseFilter
      );
      setCurrentPage(page);
    } catch (e) {
      console.log(e);
    }
    setLoad(false);
  };

  const handleIdPurchaseChange = (e) => {
    const value = e.target.value;
    setIdPurchaseSearch(value);
    if (value) {
      setSearch("");
      setPromotionSearch("");
      setStatusFilter("");
    } else {
      setStatusFilter("1");
    }
  };

  const handleClientSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (value) setIdPurchaseSearch("");
  };

  const handlePromotionSearchChange = (e) => {
    const value = e.target.value;
    setPromotionSearch(value);
    if (value) setIdPurchaseSearch("");
  };

  const handleSearch = () => {
    fetchContracts(1);
  };

  const handleUnselectContract = () => {
    setSelectedContract(null);
    fetchContracts(currentPage);
  };

  const handleStatus = (status) => {
    switch (status) {
      case 1:
        return "VALORIZANDO";
      case 2:
        return "FINALIZADO";
      case 3:
        return "CANCELADO";
      case 4:
        return "PENDENTE";
      case 5:
        return "RECOMPRADO";
      default:
        return "INDEFINIDO";
    }
  };

  const handleRemoveReceipt = async () => {
    if (removeReceiptConfirm !== "CONFIRMAR") return;
    setLoad(true);
    try {
      await contractAdminService.removeReceipt(removeReceiptModal);
      showMessage("Recibo removido com sucesso!", "success");
      setRemoveReceiptModal(null);
      setRemoveReceiptConfirm("");
      fetchContracts(currentPage);
    } catch (err) {
      showMessage("Erro ao remover o recibo.", "error");
    } finally {
      setLoad(false);
    }
  };

  const handleSelectContract = async (ctr) => {
    setSelectedContract(ctr);
    await auditService.registerContractAccess(
      ctr.contract.id,
      ctr.clientName.toUpperCase()
    );
  };

  const totalPages = Math.ceil(totalPurchases / itemsPerPage);

  return (
    <S.ContratosContainer>
      <Loading load={load} />

      {modalRecibo && (
        <ModalRecibo url={modalRecibo} onClose={() => setModalRecibo(null)} />
      )}

      {removeReceiptModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.85)",
            backdropFilter: "blur(6px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 3000,
          }}
          onClick={() => {
            setRemoveReceiptModal(null);
            setRemoveReceiptConfirm("");
          }}
        >
          <div
            style={{
              background: "#1e1e1e",
              borderRadius: "16px",
              padding: "36px",
              width: "90%",
              maxWidth: "440px",
              border: "1px solid rgba(231,76,60,0.3)",
              boxShadow: "0 20px 50px rgba(0,0,0,0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3
              style={{
                color: "#e74c3c",
                margin: "0 0 10px 0",
                fontSize: "1.1rem",
              }}
            >
              Remover Recibo
            </h3>
            <p
              style={{
                color: "#aaa",
                fontSize: "0.9rem",
                margin: "0 0 24px 0",
                lineHeight: "1.6",
              }}
            >
              Esta ação removerá o recibo do contrato{" "}
              <strong style={{ color: "#fff" }}>#{removeReceiptModal}</strong>.
              Digite <strong style={{ color: "#fff" }}>CONFIRMAR</strong> para
              prosseguir.
            </p>
            <input
              value={removeReceiptConfirm}
              onChange={(e) => setRemoveReceiptConfirm(e.target.value)}
              placeholder="CONFIRMAR"
              style={{
                width: "100%",
                height: "46px",
                borderRadius: "10px",
                border: "1px solid rgba(255,255,255,0.1)",
                background: "rgba(0,0,0,0.3)",
                color: "#fff",
                padding: "0 14px",
                fontSize: "1rem",
                boxSizing: "border-box",
                marginBottom: "16px",
              }}
            />
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
              }}
            >
              <button
                onClick={() => {
                  setRemoveReceiptModal(null);
                  setRemoveReceiptConfirm("");
                }}
                style={{
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "1px solid rgba(255,255,255,0.1)",
                  background: "transparent",
                  color: "#aaa",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handleRemoveReceipt}
                disabled={removeReceiptConfirm !== "CONFIRMAR"}
                style={{
                  padding: "10px 24px",
                  borderRadius: "10px",
                  border: "none",
                  background:
                    removeReceiptConfirm === "CONFIRMAR" ? "#e74c3c" : "#555",
                  color: "#fff",
                  cursor:
                    removeReceiptConfirm === "CONFIRMAR"
                      ? "pointer"
                      : "not-allowed",
                  fontWeight: "700",
                  transition: "background 0.2s",
                }}
              >
                Remover
              </button>
            </div>
          </div>
        </div>
      )}

      {selectedContract && (
        <PaginaContrato
          contratoData={selectedContract}
          handleClose={handleUnselectContract}
          refreshData={() => fetchContracts(currentPage)}
        />
      )}

      <S.HomeInitialContent>
        <S.Boxes>
          <S.Box>
            <S.BoxContent>
              <S.BoxTitle>Total Geral de Contratos</S.BoxTitle>
              <S.StatNumber>{totalPurchasesAtPlatform}</S.StatNumber>
            </S.BoxContent>
          </S.Box>

          <S.Box>
            <S.BoxContent>
              <S.BoxTitle>Vencendo este Mês</S.BoxTitle>
              {loadingMetrics ? (
                <S.LoadingSkeleton />
              ) : (
                <S.StatNumber>
                  {metrics?.currentMonthValorizing.quantity || 0} | R${" "}
                  {metrics?.currentMonthValorizing.totalAmount.toLocaleString(
                    "pt-BR",
                    { minimumFractionDigits: 2 }
                  )}
                </S.StatNumber>
              )}
            </S.BoxContent>
          </S.Box>

          <S.Box>
            <S.BoxContent>
              <S.BoxTitle>Vencendo Mês que Vem</S.BoxTitle>
              {loadingMetrics ? (
                <S.LoadingSkeleton />
              ) : (
                <S.StatNumber>
                  {metrics?.nextMonthValorizing.quantity || 0} | R${" "}
                  {metrics?.nextMonthValorizing.totalAmount.toLocaleString(
                    "pt-BR",
                    { minimumFractionDigits: 2 }
                  )}
                </S.StatNumber>
              )}
            </S.BoxContent>
          </S.Box>

          <S.Box>
            <S.BoxContent>
              <S.BoxTitle>Vencendo até Fim do Ano</S.BoxTitle>
              {loadingMetrics ? (
                <S.LoadingSkeleton />
              ) : (
                <S.StatNumber>
                  {metrics?.futureValorizing.quantity || 0} | R${" "}
                  {metrics?.futureValorizing.totalAmount.toLocaleString(
                    "pt-BR",
                    { minimumFractionDigits: 2 }
                  )}
                </S.StatNumber>
              )}
            </S.BoxContent>
          </S.Box>

          <S.Box>
            <S.BoxContent>
              <S.BoxTitle>Finalizados este Mês</S.BoxTitle>
              {loadingMetrics ? (
                <S.LoadingSkeleton />
              ) : (
                <S.StatNumber>
                  {metrics?.currentMonthFinished.quantity || 0} | R${" "}
                  {metrics?.currentMonthFinished.totalAmount.toLocaleString(
                    "pt-BR",
                    { minimumFractionDigits: 2 }
                  )}
                </S.StatNumber>
              )}
            </S.BoxContent>
          </S.Box>
        </S.Boxes>
      </S.HomeInitialContent>

      <S.ContentBox>
        <S.Header>
          <S.ContractsTitle>Gerenciar Contratos</S.ContractsTitle>
        </S.Header>

        <S.SearchAreaContent>
          <S.SearchInputsContainer>
            <S.SearchClient>
              <span className="title">Pesquisar por cliente</span>
              <div className="box">
                <input
                  value={search}
                  onChange={handleClientSearchChange}
                  placeholder="Nome ou CPF"
                  onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                  disabled={isSearchingById}
                />
              </div>
            </S.SearchClient>
            <S.SearchClient>
              <span className="title">Pesquisar por Campanha</span>
              <div className="box">
                <input
                  value={promotionSearch}
                  onChange={handlePromotionSearchChange}
                  placeholder="Nome da Campanha"
                  onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                  disabled={isSearchingById}
                />
              </div>
            </S.SearchClient>
            <S.SearchClient>
              <span className="title">Pesquisar por Contrato</span>
              <div className="box">
                <input
                  value={idPurchaseSearch}
                  onChange={handleIdPurchaseChange}
                  placeholder="ID"
                  type="number"
                  onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                />
                <button onClick={handleSearch}>
                  <FaSearch />
                </button>
              </div>
            </S.SearchClient>
          </S.SearchInputsContainer>

          <S.FiltersRow>
            <S.FilterDiv>
              <h4>Status</h4>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                disabled={isSearchingById}
              >
                <option value="">TODOS</option>
                <option value="1">VALORIZANDO</option>
                <option value="2">FINALIZADOS</option>
                <option value="3">CANCELADOS</option>
              </select>
            </S.FilterDiv>
            <S.FilterDiv>
              <h4>Ordenar por</h4>
              <select
                value={orderFilter}
                onChange={(e) => setOrderFilter(e.target.value)}
                disabled={isSearchingById}
              >
                <option value="date_desc">Mais Recentes</option>
                <option value="date_asc">Mais Antigos</option>
                <option value="value_desc">Maior Valor</option>
                <option value="value_asc">Menor Valor</option>
              </select>
            </S.FilterDiv>
            <S.FilterDiv>
              <h4>Recompra</h4>
              <select
                value={isRepurchaseFilter}
                onChange={(e) => setIsRepurchaseFilter(e.target.value)}
                disabled={isSearchingById}
              >
                <option value="">TODOS</option>
                <option value="true">SIM</option>
                <option value="false">NÃO</option>
              </select>
            </S.FilterDiv>
          </S.FiltersRow>
        </S.SearchAreaContent>

        <S.TableContainer>
          <S.Table>
            <S.TableHeader>
              <S.TableRow>
                <S.TableHeaderCell>Data</S.TableHeaderCell>
                <S.TableHeaderCell>ID</S.TableHeaderCell>
                <S.TableHeaderCell>Cliente</S.TableHeaderCell>
                <S.TableHeaderCell>CPF</S.TableHeaderCell>
                <S.TableHeaderCell>Valor Invest.</S.TableHeaderCell>
                <S.TableHeaderCell>Campanha</S.TableHeaderCell>
                <S.TableHeaderCell>É Recompra?</S.TableHeaderCell>
                <S.TableHeaderCell>Lucro Atual (%)</S.TableHeaderCell>
                <S.TableHeaderCell>Disp. para Saque</S.TableHeaderCell>
                <S.TableHeaderCell>Primeira Valorização</S.TableHeaderCell>
                <S.TableHeaderCell>Próxima Data de Saque</S.TableHeaderCell>
                <S.TableHeaderCell>Criado Por</S.TableHeaderCell>
                <S.TableHeaderCell>Aprovado/Cancelado Por</S.TableHeaderCell>
                <S.TableHeaderCell>Recibo</S.TableHeaderCell>
                <S.TableHeaderCell>Status</S.TableHeaderCell>
              </S.TableRow>
            </S.TableHeader>
            <S.TableBody>
              {purchases.map((ctr) => (
                <S.TableRow
                  onClick={() => handleSelectContract(ctr)}
                  key={ctr.contract.id}
                >
                  <S.TableCell>
                    {formatDateSystem(ctr.contract.dateCreated)}
                  </S.TableCell>
                  <S.TableCell>{ctr.contract.id}</S.TableCell>
                  <S.TableCell>{ctr.clientName.toUpperCase()}</S.TableCell>
                  <S.TableCell>{ctr.clientCpfCnpj}</S.TableCell>
                  <S.TableCell>
                    R$ {ctr.contract.totalPrice?.toFixed(2)}
                  </S.TableCell>
                  <S.TableCell>
                    {ctr.contract.promotionName || "Não informado"}
                  </S.TableCell>
                  <S.TableCell>
                    {ctr.contract.isRepurchase ? "Sim" : "Não"}
                  </S.TableCell>
                  <S.TableCell>
                    {ctr.contract.actualValorization?.toFixed(2)}%
                  </S.TableCell>
                  <S.TableCell>
                    R${" "}
                    {ctr.avaliableToWithdraw > 0
                      ? formatNumber(ctr.avaliableToWithdraw)
                      : formatNumber(0)}
                  </S.TableCell>
                  <S.TableCell>
                    {ctr.contract.firstValorization
                      ? formatDateDisplay(ctr.contract.firstValorization)
                      : "---"}
                  </S.TableCell>
                  <S.TableCell>
                    <strong
                      style={{
                        color:
                          getNextWithdrawalFromList(
                            ctr.contract.withdrawDates
                          ) === "HOJE"
                            ? "#00ff00"
                            : "inherit",
                      }}
                    >
                      {getNextWithdrawalFromList(ctr.contract.withdrawDates)}
                    </strong>
                  </S.TableCell>
                  <S.TableCell>
                    {ctr.contract.createdBy || "Não Informado"}
                  </S.TableCell>
                  <S.TableCell>
                    {ctr.contract.approvedByName ||
                      ctr.contract.deniedByName ||
                      "Não Informado"}
                  </S.TableCell>
                  <S.TableCell onClick={(e) => e.stopPropagation()}>
                    {ctr.contract.receiptUrl ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "6px",
                          alignItems: "center",
                        }}
                      >
                        <button
                          onClick={() =>
                            setModalRecibo(ctr.contract.receiptUrl)
                          }
                          style={{
                            background: "rgba(212,175,55,1)",
                            color: "black",
                            cursor: "pointer",
                            padding: "5px 10px",
                            border: "none",
                            borderRadius: "4px",
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Ver Recibo
                        </button>
                        <button
                          onClick={() => {
                            setRemoveReceiptModal(ctr.contract.id);
                            setRemoveReceiptConfirm("");
                          }}
                          style={{
                            background: "#c0392b",
                            color: "#fff",
                            cursor: "pointer",
                            padding: "5px 10px",
                            border: "none",
                            borderRadius: "4px",
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Remover
                        </button>
                      </div>
                    ) : (
                      <span style={{ color: "#666" }}>Não Anexado</span>
                    )}
                  </S.TableCell>
                  <S.TableCell>{handleStatus(ctr.contract.status)}</S.TableCell>
                </S.TableRow>
              ))}
            </S.TableBody>
          </S.Table>
        </S.TableContainer>

        <S.PaginationContainer>
          <S.PaginationButton
            onClick={() => fetchContracts(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Anterior
          </S.PaginationButton>
          <span>
            Página {currentPage} de {totalPages > 0 ? totalPages : 1}
          </span>
          <S.PaginationButton
            onClick={() => fetchContracts(currentPage + 1)}
            disabled={currentPage >= totalPages}
          >
            Próxima
          </S.PaginationButton>
        </S.PaginationContainer>
      </S.ContentBox>
    </S.ContratosContainer>
  );
}
